import { render, staticRenderFns } from "./currentCall.vue?vue&type=template&id=67dc3624"
import script from "./currentCall.vue?vue&type=script&lang=js"
export * from "./currentCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports